import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { QuizForm } from '../Quiz/QuizForm';
import { CrosswordForm } from '../Crossword/CrosswordForm';
import { WordSearchForm } from '../WordSearch/WordSearchForm';
import { Loading } from '../UI/Loading';
import { setlastCreatedQuizId } from '../../redux/reducers/quizzes';
import { setlastCreatedCrosswordId } from '../../redux/reducers/crosswords';
import { createQuiz } from '../../redux/actions/quizzes';
import { createCrossword } from '../../redux/actions/crosswords';
import { loading } from '../../redux/selectors/loading';
import { createWordSearch } from '../../redux/actions/word-searches';
import { setlastCreatedWordSearchId } from '../../redux/reducers/word-searches';
const AddDetailsComponent = ({ loading, type, lastCreatedQuizId, setlastCreatedQuizId, createQuiz, lastCreatedCrosswordId, setlastCreatedCrosswordId, createCrossword, createWordSearch, lastCreatedWordSearchId, setlastCreatedWordSearchId, setKreeda, setCurrentStep, }) => {
    const navigate = useNavigate();
    if (loading) {
        return React.createElement(Loading, null);
    }
    switch (type) {
        case 'quiz':
            if (lastCreatedQuizId) {
                return (React.createElement("div", { className: "centered" },
                    React.createElement("button", { className: "btn--primary", onClick: () => {
                            const modal = document.getElementById('create-kreeda');
                            if (modal) {
                                modal.style.display = 'none';
                            }
                            setKreeda({
                                type: '',
                                details: {
                                    name: '',
                                    duration: '',
                                },
                                settings: {
                                    public: false,
                                    shuffleQuestions: false,
                                    sendResultEmail: false,
                                    timed: false,
                                },
                            });
                            setCurrentStep(0);
                            const quiId = lastCreatedQuizId;
                            setlastCreatedQuizId({ quizId: undefined });
                            navigate(`/quizzes/${quiId}`);
                        } }, "Finish")));
            }
            return (React.createElement(QuizForm, { onSubmit: (quiz) => {
                    createQuiz(quiz);
                }, onCancel: () => {
                    setKreeda({
                        type: '',
                        details: {
                            name: '',
                            duration: '',
                        },
                        settings: {
                            public: false,
                            shuffleQuestions: false,
                            sendResultEmail: false,
                            timed: false,
                        },
                    });
                    setCurrentStep(0);
                } }));
        case 'crossword':
            if (lastCreatedCrosswordId) {
                return (React.createElement("div", { className: "centered" },
                    React.createElement("button", { className: "btn--primary", onClick: () => {
                            const modal = document.getElementById('create-kreeda');
                            if (modal) {
                                modal.style.display = 'none';
                            }
                            setKreeda({
                                type: '',
                                details: {
                                    name: '',
                                    duration: '',
                                },
                                settings: {
                                    public: false,
                                    randomiseGrid: false,
                                    sendResultEmail: false,
                                    timed: false,
                                },
                            });
                            setCurrentStep(0);
                            const crosswordId = lastCreatedCrosswordId;
                            setlastCreatedCrosswordId({ crosswordId: undefined });
                            navigate(`/crosswords/${crosswordId}`);
                        } }, "Finish")));
            }
            return (React.createElement(CrosswordForm, { onSubmit: (crossword) => {
                    createCrossword(crossword);
                }, onCancel: () => {
                    setKreeda({
                        type: '',
                        details: {
                            name: '',
                            duration: '',
                        },
                        settings: {
                            public: false,
                            randomiseGrid: false,
                            sendResultEmail: false,
                            timed: false,
                        },
                    });
                    setCurrentStep(0);
                } }));
        case 'word-search':
            if (lastCreatedWordSearchId) {
                return (React.createElement("div", { className: "centered" },
                    React.createElement("button", { className: "btn--primary", onClick: () => {
                            const modal = document.getElementById('create-kreeda');
                            if (modal) {
                                modal.style.display = 'none';
                            }
                            setKreeda({
                                type: '',
                                details: {
                                    name: '',
                                    duration: '',
                                },
                                settings: {
                                    public: false,
                                    randomiseGrid: false,
                                    sendResultEmail: false,
                                    timed: false,
                                },
                            });
                            setCurrentStep(0);
                            const wordSearchId = lastCreatedWordSearchId;
                            setlastCreatedWordSearchId({ wordSearchId: undefined });
                            navigate(`/word-searches/${wordSearchId}`);
                        } }, "Finish")));
            }
            return (React.createElement(WordSearchForm, { onSubmit: (wordsearch) => {
                    createWordSearch(wordsearch);
                }, onCancel: () => {
                    setKreeda({
                        type: '',
                        details: {
                            name: '',
                            duration: '',
                        },
                        settings: {
                            public: false,
                            randomiseGrid: false,
                            sendResultEmail: false,
                            timed: false,
                        },
                    });
                    setCurrentStep(0);
                } }));
    }
};
const mapStateToProps = (state) => {
    return {
        loading: loading(state.quizState.loading, state.crosswordState.loading),
        error: state.quizState.error,
        errorDetail: state.quizState.errorDetail,
        lastCreatedQuizId: state.quizState.lastCreatedQuizId,
        lastCreatedCrosswordId: state.crosswordState.lastCreatedCrosswordId,
        lastCreatedWordSearchId: state.wordSearchState.lastCreatedWordSearchId,
    };
};
const mapDispatchToProps = {
    createQuiz,
    setlastCreatedQuizId,
    createCrossword,
    setlastCreatedCrosswordId,
    createWordSearch,
    setlastCreatedWordSearchId,
};
export const AddDetails = connect(mapStateToProps, mapDispatchToProps)(AddDetailsComponent);
